// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconEntertainmentLeisurePath = 'm12.105 0-.231.677A1.973 1.973 0 0 1 10 2C9.15 2 8.397 1.468 8.127.677L7.895 0H2v20h5.895l.232-.677A1.971 1.971 0 0 1 10 18c.85 0 1.603.532 1.874 1.323l.231.677H18V0h-5.895Zm1.356 18A3.981 3.981 0 0 0 10 16c-1.452 0-2.765.78-3.461 2H4V7l.004 1 3-.013-.008-2L4 6V2h2.539C7.235 3.22 8.548 4 10 4s2.765-.78 3.461-2H16v4.987l-.004-1-3 .013.008 2L16 7.987V18h-2.539Zm-1.46-10H8V6h4v2Z';
var IconEntertainmentLeisure = baseIcon('IconEntertainmentLeisure', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconEntertainmentLeisurePath
});
export default IconEntertainmentLeisure;
//# sourceMappingURL=index.js.map